export enum CartCostTypeEnum {
  Item = 'item',
  Delivery = 'delivery',
  Commission = 'commission',
  DroitDeSuite = 'droitDeSuite',
  Taxes = 'taxes'
}
